var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanklogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ECEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 6.5L7.4043 11.0238V12.8333H24.5948V11.0238M20.071 14.6429V20.9762H22.7852V14.6429M7.4043 25.5H24.5948V22.7857H7.4043M14.6424 14.6429V20.9762H17.3567V14.6429M9.21382 14.6429V20.9762H11.9281V14.6429H9.21382Z",
    fill: "#514C9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanklogo);
export default __webpack_public_path__ + "static/media/banklogo.5f9b8a877b775392517af8b5558980bf.svg";
export { ForwardRef as ReactComponent };